import { Loader2 } from "lucide-react";
import React from "react";

const ButtonLoader = ({ size = 24, className = "", color = "currentColor" }) => {
  return (
    <div className="w-full flex items-center justify-center">
      <Loader2 size={size} className={`animate-spin ${className}`} color={color} />
    </div>
  );
};

export default ButtonLoader;
